module.exports = " <!-- BEGIN FOOTER -->\r\n<p class=\"copyright\">\r\n    {{Now | date: 'y'}} &copy; Medical Support Offshore - {{AppVersion}}\r\n</p>\r\n<!-- END FOOTER -->\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/footer/footer.component.html
// module id = 1086
// module chunks = 1